<template>
  <div class="main-body">
    <div class="header">报警信息</div>
    <div class="out">

      <div class="search2">
        <div style="float:right">

          <el-select v-model="type" clearable placeholder="请选择报警类型" title="报警类型" style="width:200px;margin-right:10px">
            <el-option
                v-for="item in typeValue"
                :key="item[0]"
                :label="item[1]"
                :value="item[0]">
            </el-option>
          </el-select>


          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="选择区域" v-on:getZoneValue="getZoneValue" :value='zoneCode'
                        style="width:200px;margin-right:10px"></elSelectTree>

          <el-date-picker style="margin-right: 10px;width:320px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm"
                          format="yyyy-MM-dd HH:mm"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>


          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>
        <el-table-column prop="userName" label="报警人"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
        <el-table-column label="处理状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">未处理</span>
            <span v-if="scope.row.status==1">已处理</span>
          </template>
        </el-table-column>
        <el-table-column prop="dealMessage" label="处理结果"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
        <el-table-column prop="type" :formatter="getType" label="报警类型"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="location" label="位置"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="报警时间"></el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import {getStaffCode, getToken} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree"

export default {
  name: "Page",
  data(){
    return{

      tableLoading:false,

      showModalDeal:false,
      showModalEdit:false,

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      startEndTime:[],

      typeValue:[[2,'紧急按钮'],[3,'红外探测器'],[4,'门磁传感器'],[5,'水浸传感器'],[6,'网关报警'],
        [7,'睡倍健报警'],[8,'手表SOS报警'],[9,'燃气泄漏报警器'],[10,'烟雾探测器'], [12,'App一键求助']],
      type:'',


      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      zoneValue: [],
      zoneCode: '',


    }
  },
  components:{
    elSelectTree
  },
  created(){

    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
    this.startEndTime = [start, end];

    this.getZone();
    this.th = this.$store.state.tableHeight;

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    closeDeal(){
      this.showModalDeal = false;
    },
    handleStatus(row){
      this.showModalDeal = true;
      this.$refs.myDeal.init(row.alarmRecordCode,row.userName);
    },

    timefilter(row,index,column){
      return timefilters(column)
    },
    getType(row,index,column){
      var type='其他'
      this.typeValue.forEach(val=>{
        if(val[0]==column){
          type=val[1]
        }
      })
      return type
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: JSON.parse(getToken()).governmentCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,

          type:this.type,
          startTime: timefilters(this.startEndTime[0]),
          endTime: timefilters(this.startEndTime[1]),
          zoneCode:this.zoneCode,

        }
      }).then( (response)=> {
        //console.log(response);
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },



    getZone(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        //console.log(response.data.data);
        if (response.data.error == 0) {
          var data = JSON.stringify(response.data.data);

          //console.log(data.replace(/"listZoneDTO":\[\],/g, ''));

          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
          this.zoneValue = data;
          this.zoneCode = data[0].zoneCode;

          this.getList();

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      })

    },

    getZoneValue(val) {
      this.zoneCode = val
    },

  }
}
</script>

<style scoped>

.main-body{
  background-color: #f2f2f2;height: 100%;
}

.main-body .header{
  background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;
}

.main-body .out {
  padding: 10px;
}

.main-body .out .search{

}

.main-body .out .table {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.main-body .out .page {
  background-color: #fff;padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

</style>
